"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const services = [{
  label: "Spine Surgery",
  href: "/spine-surgery"
}, {
  label: "Pain Management",
  href: "/pain-management"
}, {
  label: "Rehabilitation Services",
  href: "/your-journey#egle-sanatorium"
}, {
  label: "Pre- and Post-Operative Care",
  href: "/your-journey"
}, {
  label: "Consultations for Spinal Conditions",
  href: "/#request-your-consultation"
}];
const navigationLinks = [{
  label: "Pain Management",
  href: "/pain-management"
}, {
  label: "Spine Surgery",
  href: "/spine-surgery"
}, {
  label: "Our Specialists",
  href: "/our-specialists"
}, {
  label: "Your Journey",
  href: "/your-journey"
}, {
  label: "HSE Reimbursement",
  href: "/how-it-works/"
}, {
  label: "Costs",
  href: "/costs"
}, {
  label: "FAQ",
  href: "/faq"
}, {
  label: "Contact",
  href: "/contact"
}];
export default function ClinicAgatasInformation() {
  return <section id="clinic-agatas-information" className="bg-[#264256] pt-8 pb-8 md:pt-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-8 mb-8 md:mb-12">

          <div className="flex flex-col items-center text-center md:items-start md:text-left">
            <Link to="/" className="inline-block mb-6">
              <img src="https://painreliefabroad.ie/wp-content/uploads/2026/05/Agatas-logo_vertikalus.-spalvotas-sviesus.png" alt="Clinic Agatas Logo" className="w-auto !h-[230px]" />
            </Link>
            <div className="flex gap-3">
              {[{
              icon: Facebook,
              href: "https://www.facebook.com/clinicagatas/?locale=en_GB",
              label: "Facebook"
            }, {
              icon: Instagram,
              href: "https://www.instagram.com/clinicagatas/?hl=en",
              label: "Instagram"
            }, {
              icon: Linkedin,
              href: "https://www.linkedin.com/company/clinic-agatas/",
              label: "LinkedIn"
            }].map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} data-index={i} className="w-10 h-10 rounded-full bg-[#65d19d] text-[#264256] flex items-center justify-center hover:bg-[#65d19d]/90 transition-colors" aria-label={social.label}>
                  <Icon className="w-5 h-5" />
                </Link>;
            })}
            </div>
          </div>

          <div>
            <h4 className="font-default font-semibold text-[#65d19d] mb-4 text-lg">Services</h4>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                <Link to={service.href} className="text-[#ffffff] hover:text-[#65d19d] transition-colors text-sm">
                  {service.label}
                </Link>
              </li>)}
            </ul>
          </div>

          <div>
            <h4 className="font-default font-semibold text-[#65d19d] mb-4 text-lg">Navigation</h4>
            <ul className="space-y-3">
              {navigationLinks.map((link, i) => <li key={i} data-index={i}>
                <Link to={link.href} className="text-[#ffffff] hover:text-[#65d19d] transition-colors text-sm">
                  {link.label}
                </Link>
              </li>)}
            </ul>
          </div>

          <div>
            <h4 className="font-default font-semibold text-[#65d19d] mb-4 text-lg">Contact Details</h4>
            <div className="space-y-6">
              <div>
                <h5 className="font-default font-medium text-[#ffffff] text-sm mb-2">Klinika Agatas Ltd.</h5>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-sm text-[#ffffff]">
                    <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#65d19d]" />
                    <Link to="https://maps.google.com/?q=Linkuvos+g.+60,+Kaunas,+Lithuania" newTab className="hover:text-[#65d19d] transition-colors">Linkuvos st. 60, Kaunas, Lithuania</Link>
                  </li>
                  <li className="flex items-center gap-2 text-sm text-[#ffffff]">
                    <Phone className="w-4 h-4 shrink-0 text-[#65d19d]" />
                    <a href="tel:+37060226118" className="hover:text-[#65d19d] transition-colors">+370 602 26118</a>
                  </li>
                  <li className="flex items-center gap-2 text-sm text-[#ffffff]">
                    <Mail className="w-4 h-4 shrink-0 text-[#65d19d]" />
                    <a href="mailto:info@clinicagatas.com" className="hover:text-[#65d19d] transition-colors">info@clinicagatas.com</a>
                  </li>
                </ul>
              </div>
              <div>
                <h5 className="font-default font-medium text-[#ffffff] text-sm mb-2">Irish Coordinator Mindaugas (Minde)</h5>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2 text-sm text-[#ffffff]">
                    <Phone className="w-4 h-4 shrink-0 text-[#65d19d]" />
                    <a href="tel:+353871753061" className="hover:text-[#65d19d] transition-colors">+353 871 753 061</a>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-[#ffffff]">
                    <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#65d19d]" />
                    <Link to="https://maps.app.goo.gl/QiAMjasrBSg8bQ4f6" newTab className="hover:text-[#65d19d] transition-colors">Paryžiaus Komunos g. 2A, Klaipėda, Lithuania</Link>
                  </li>
                  <li className="flex items-center gap-2 text-sm text-[#ffffff] mt-1">
                    <span className="font-default font-medium text-sm">Baltic Clinic Ltd.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <Separator className="bg-[#a9e5c9]/20" />

        <div className="mt-8 text-center space-y-2">
          <p className="text-sm text-[#a9e5c9]">
            © {new Date().getFullYear()} Clinic Agatas. All rights reserved.
          </p>
          <div className="flex items-center justify-center gap-3 text-sm text-[#a9e5c9]">
            <Link className="hover:text-[#65d19d] transition-colors" to="#">
              Privacy Policy
            </Link>
            <span aria-hidden="true" className="opacity-60">•</span>
            <Link className="hover:text-[#65d19d] transition-colors" to="#">
              Cookie Policy
            </Link>
          </div>
          <p className="text-xs text-[#a9e5c9]/70 max-w-3xl mx-auto">
            The information on this website is for general educational purposes only and is not a substitute for professional medical advice, diagnosis or treatment. Always seek the advice of a qualified doctor with any questions about a medical condition. Suitability for any procedure is determined only after a personal medical assessment.
          </p>
        </div>
      </div>
    </section>;
}